module.exports = __webpack_public_path__ + "img/BOOK.fe81629c.png";